import { Ref, forwardRef, MouseEvent } from "react";
import { useHref, useLinkClickHandler } from "react-router-dom";
import TrackingAnchor from "../trackingAnchor";

import { types } from "./definitions";

/**
 * Based on example from react-router-dom migration guider
 * https://reactrouter.com/en/main/upgrading/v5#remove-link-component-prop
 */
const PasteLink = forwardRef(
  (
    {
      children,
      to,
      replace,
      state,
      target,
      onClick,
      trackEvent,
      noUnderline,
    }: types.PasteLinkProps,
    ref: Ref<HTMLAnchorElement>
  ) => {
    const href = useHref(to);
    const handleClick = useLinkClickHandler(to, {
      replace,
      // Commenting out due to false error in local dev environment
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      state,
      target,
    });

    return (
      <TrackingAnchor
        onClick={(event: MouseEvent<HTMLAnchorElement>): void => {
          onClick?.(event);
          if (!event.defaultPrevented) {
            handleClick(event);
          }
        }}
        href={href}
        ref={ref}
        trackEvent={trackEvent}
        noUnderline={noUnderline}
      >
        {children}
      </TrackingAnchor>
    );
  }
);

export default PasteLink;
